import { MapPin, Home } from 'lucide-react'
import { useState } from 'react'
import { Input } from '#app/components/ui/input'
import { Label } from '#app/components/ui/label'

interface AddressComponents {
  street?: string
  houseNumber?: string
  postalCode?: string
  city?: string
  formatted?: string
}

interface SimpleAddressSearchProps {
  onAddressSelect: (address: AddressComponents) => void
}

export function SimpleAddressSearch({ onAddressSelect }: SimpleAddressSearchProps) {
  const [address, setAddress] = useState<AddressComponents>({
    street: '',
    houseNumber: '',
    postalCode: '',
    city: ''
  })

  const handleChange = (field: keyof AddressComponents, value: string) => {
    const updated = { ...address, [field]: value }
    
    // Create formatted address
    const parts = []
    if (updated.street) parts.push(updated.street)
    if (updated.houseNumber) parts.push(updated.houseNumber)
    if (updated.postalCode) parts.push(updated.postalCode)
    if (updated.city) parts.push(updated.city)
    updated.formatted = parts.filter(Boolean).join(', ')
    
    setAddress(updated)
    onAddressSelect(updated)
  }

  return (
    <div className="space-y-4">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-800">
        <MapPin className="inline-block h-4 w-4 mr-1" />
        Google Maps API niet geconfigureerd - gebruik handmatige invoer
      </div>

      <div className="grid gap-4">
        <div className="grid grid-cols-3 gap-4">
          <div className="col-span-2">
            <Label htmlFor="street">Straat</Label>
            <Input
              id="street"
              type="text"
              placeholder="Hoofdstraat"
              value={address.street}
              onChange={(e) => handleChange('street', e.target.value)}
              className="mt-1"
            />
          </div>
          <div>
            <Label htmlFor="houseNumber">Huisnummer</Label>
            <Input
              id="houseNumber"
              type="text"
              placeholder="123"
              value={address.houseNumber}
              onChange={(e) => handleChange('houseNumber', e.target.value)}
              className="mt-1"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label htmlFor="postalCode">Postcode</Label>
            <Input
              id="postalCode"
              type="text"
              placeholder="1234 AB"
              value={address.postalCode}
              onChange={(e) => handleChange('postalCode', e.target.value)}
              className="mt-1"
            />
          </div>
          <div>
            <Label htmlFor="city">Plaats</Label>
            <Input
              id="city"
              type="text"
              placeholder="Amsterdam"
              value={address.city}
              onChange={(e) => handleChange('city', e.target.value)}
              className="mt-1"
            />
          </div>
        </div>
      </div>

      {address.formatted && (
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <div className="flex items-center text-gray-700">
            <Home className="h-4 w-4 mr-2 text-gray-400" />
            <p className="text-sm font-medium">{address.formatted}</p>
          </div>
        </div>
      )}
    </div>
  )
}